import Schema from 'AppReact/schema';

export default {
  left: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  startDateEntry: Schema('string', 'primitive-nullable', { defaultValue: '' }),
  endDateEntry: Schema('string', 'primitive-nullable', { defaultValue: '' }),

  startDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  endDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  disabledBefore: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),

  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
}